import React from 'react';

import styles from './styles.module.css';
import logoTypes from './data.ts';

type Props = {
  type: keyof typeof logoTypes;
};

const ProductActivityStatusLogo: React.FC<Props> = ({ type }) => {
  if (!logoTypes[type]) return null;

  return (
    <img
      alt="Product Activity Card Status Logo"
      data-testid="activity-status-logo"
      src={logoTypes[type]}
      className={styles.logo}
    />
  );
};

export { logoTypes };

export default ProductActivityStatusLogo;
